module.exports = __webpack_public_path__ + "59c2eb3b131ce9b17c4e5d07b49e2bdc.png";